<script lang="ts" setup>
import usePlayHandleAnonymously from '@/composables/helpers/usePlayHandleAnonymously';

const { playHandleAnonymously, getIsHandleAnonymouslyPlayed } =
  usePlayHandleAnonymously();

const mounted = ref(false);

const isPlayed = ref(false);

const heading = computed(() => {
  return isPlayed.value ? 'You’ve played your first Handle…' : 'Let’s Play!';
});

const playButtonIsVisible = computed(() => {
  return mounted.value && !isPlayed.value;
});

onMounted(async () => {
  isPlayed.value = await getIsHandleAnonymouslyPlayed();
  mounted.value = true;
});
</script>

<template>
  <AuthPageWrapper :loading="!mounted">
    <div class="grid gap-3">
      <h1 class="text-2xl font-medium text-brand-navy-700 text-center">
        {{ heading }}
      </h1>
      <p class="text-lg leading-6 text-brand-navy-700 text-center">
        <template v-if="mounted && isPlayed">
          Can you handle more? <br class="md:hidden" />
          Play free for <span class="font-bold">30 days…</span>
        </template>
        <template v-else>
          Try Handle for free for<br class="md:hidden" />
          <span class="font-bold"> 30 days</span>
        </template>
      </p>
    </div>
    <BenefitsList />
    <div class="flex flex-col flex-wrap items-center justify-center">
      <div :class="['w-full flex flex-col items-center justify-center']">
        <Button block class-name="md:w-[200px]" to="/sign-up">
          Free Sign Up *
        </Button>
        <p
          class="mt-1.5 text-center text-brand-navy-700 text-base leading-5 font-bold"
        >
          No payment card needed. The only cards are playing cards.
        </p>
      </div>
    </div>
    <p class="text-lg leading-6 text-center text-brand-navy-700 font-medium">
      Have an account already?
      <NuxtLink to="/login" class="font-bold underline">Log In</NuxtLink>
    </p>
    <p class="text-sm text-brand-navy-700">
      *You can still play Handle every week if you don’t sign up, but you’re
      limited to the Sunday deals. Sign up for a daily deal - and for the weekly
      newsletter (including a bonus lesson). After your 30-day free go,
      subscription costs £48/year or £6/month.
      <template v-if="playButtonIsVisible">
        To play without signing up:
        <span
          class="underline cursor-pointer font-bold"
          @click="playHandleAnonymously"
        >
          Just Play.
        </span>
      </template>
    </p>
  </AuthPageWrapper>
</template>

<style lang="scss" scoped></style>
